<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Udostepnianie plików'" [name]="'Lista'"></app-breadcrumb>
<div class="file-manager-list-container">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="file-manager-list-filters">

    </form>
  </div>


  <div fxLayout="row" fxLayoutGap="15px" style="margin-bottom: 15px">
    <!--    <button *ngIf="(userPermissions | async)?.terminals.write" (click)="addTerminal()" class="report-button" mat-raised-button color="primary">-->
    <!--      <mat-icon>add</mat-icon>-->
    <!--      <span> Dodaj </span></button>-->
<!--    <button *ngIf="idValue" (click)="back()"  class="report-button" mat-raised-button color="primary">-->
<!--      <mat-icon>arrow_back</mat-icon>-->
<!--      <span> Powrót </span></button>-->
<!--    <button *ngIf="(userPermissions | async)?.file_manager.create" (click)="addFile()"  class="report-button" mat-raised-button color="primary">-->
<!--      <mat-icon>note_add</mat-icon>-->
<!--      <span> Dodaj plik </span></button>-->
    <button *ngIf="(userPermissions | async)?.file_sharing.create" (click)="add()"  class="report-button" mat-raised-button color="primary">
      <mat-icon>add</mat-icon>
      <span> Dodaj  </span></button>



    <!--    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>-->
    <!--    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>-->
  </div>

  <div fxLayout="column">


    <table mat-table [dataSource]="sharedFile">

      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef> Nazwa</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fileName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="cratedAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
        <td mat-cell *matCellDef="let element">
          {{element.createdAt | date:'y-MM-dd'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="removeAt">
        <th mat-header-cell *matHeaderCellDef> Data wygaśnięcia</th>
        <td mat-cell *matCellDef="let element">
          {{element.removeAt | date:'y-MM-dd'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef> Użytkownik</th>
        <td mat-cell *matCellDef="let element">
          {{element.createdBy }}
        </td>
      </ng-container>

      <ng-container matColumnDef="pasword">
        <th mat-header-cell *matHeaderCellDef> Hasło</th>
        <td mat-cell *matCellDef="let element">
          {{element.password ? 'TAK' : 'NIE'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="download">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">

          <button
            [disabled]="!(userPermissions | async)?.file_sharing.read || isExpired(element.removeAt)"
            (click)="getLink(element)"
            mat-raised-button>
            Wygeneruj link
          </button>
          <button *ngIf="(userPermissions | async).file_sharing.admin_root ||( element.userId === profile.userId  && (userPermissions | async).file_sharing.delete)" [disabled]="!(userPermissions | async).file_sharing.admin_root && element.userId !== profile.userId"  (click)="deleteSharedFile(element.uuid)"  mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>


        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
</div>
